import { allowAuthFailurePageView } from '@app/constants/authFailureGate';
import { triggerAuthFailureNavigation } from '@app/store/appState';
import {
  isSigningOut,
  setSigningOutGate,
  clearSigningOutGate,
} from '@app/constants/signOutGate';

class NavigationService {
  constructor() {
    this.dispatch = null;
  }

  setDispatch(dispatch) {
    this.dispatch = dispatch;
  }

  // Logout intentionally tears down credentials (Bennie signal cookie + Okta
  // tokens), so any authenticated request in flight during that window resolves
  // 401/403. Marking the sign-out lets triggerAuthFailure ignore those expected
  // failures instead of bouncing the user to /auth-failure mid-logout.
  beginSignOut() {
    setSigningOutGate();
  }

  endSignOut() {
    clearSigningOutGate();
  }

  triggerAuthFailure() {
    if (isSigningOut()) {
      return;
    }

    if (this.dispatch) {
      this.dispatch(triggerAuthFailureNavigation());
      return;
    }

    // eslint-disable-next-line no-console
    console.error(
      'NavigationService: dispatch not set, falling back to window.location',
    );
    allowAuthFailurePageView();
    window.location.href = '/auth-failure';
  }
}

// Export singleton instance
export default new NavigationService();
